export enum MultiselectOptionType {
  entry, new, project_search, all, moremarker
}
